import { Avatar } from '@calendly/ui/components/avatar';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { getRule } from 'components/availability/form/utils';
import { summarizeAvailabilityRule } from 'components/event_type_edit';
import { useEventType } from 'features/event_type_provider';
import { timeNotationSelector } from 'selectors/current_user';
import { Accordion, AccordionItem } from './accordion';
import { MeetingExceptions } from './meeting_exceptions';
const containerCss = "c1rp57bm";
const Container = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(containerCss, props.className)} />);
const hostContainerCss = "hk3kj7e";
const HostContainer = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(hostContainerCss, props.className)} />);
const meetingExceptionsContainerCss = "myjkhpi";
const MeetingExceptionsContainer = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(meetingExceptionsContainerCss, props.className)} />);
const HostItem = ({
  member
}) => {
  const eventType = useEventType();
  const timeNotation = useSelector(timeNotationSelector);
  const rule = getRule(member, eventType);
  const summary = summarizeAvailabilityRule(rule, timeNotation);
  return <HostContainer>
      <FullStoryExclude>
        <Avatar size="small" src={member.avatar.url} letter={member.avatar.letter} />
      </FullStoryExclude>
      <div>
        <BodyText size="medium">
          <FullStoryMask>
            {member.name}
          </FullStoryMask>
        </BodyText>
        <BodyText size="x-small" color="muted">{summary}</BodyText>
      </div>
    </HostContainer>;
};
export const MultiHost = ({
  doubleBookingRuleMemberships
}) => <Container>
    <Accordion>
      {doubleBookingRuleMemberships.map((doubleBookingRuleMembership, index) => <AccordionItem key={doubleBookingRuleMembership.id} header={<HostItem member={doubleBookingRuleMembership} />}>
          <MeetingExceptionsContainer>
            <MeetingExceptions doubleBookingRuleMembership={doubleBookingRuleMembership} doubleBookingRuleMembershipIndex={index} />
          </MeetingExceptionsContainer>
        </AccordionItem>)}
    </Accordion>
  </Container>;

require("./multi_host.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./multi_host.js");